import React from "react";
import { TabControler } from "component/TabControler/TabControler";
import { PolygonsProps, PolygonsTabsType } from "./types";
import GeneralContainer from "./general/GeneralContainer";
import Pricing from "./pricing/PricingContainer";
import FilterPolygons from "./filter/FilterPolygonsContainer";
import { useTranslation } from "react-i18next";
import "./Polygons.scss";
import "./i18n";

export const Polygons = ({
  tabs,
  actualPage,
  testId,
  changePage,
}: PolygonsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="header-container">
        <TabControler<PolygonsTabsType>
          tabs={tabs}
          changePage={(page) => changePage(page)}
          actualPage={actualPage}
          clickable={false}
        />
      </div>
      <div className="polygons-container">
        <div className="polygons-title">
          <h2 className="subTitle-pending">
            <p
              className="subtitle-pendingUser-h2"
              data-testId={`${testId}-title`}
            >
              {t("polygon:polygons")}
            </p>
          </h2>
        </div>
        <FilterPolygons testId={`${testId}-filters`} />
      </div>
      <div className="polygons-container">
        {actualPage === "general" ? (
          <GeneralContainer testId={`${testId}-general`} />
        ) : (
          <Pricing testId={`${testId}-pricing`} />
        )}
      </div>
    </>
  );
};
